// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.show-history-switch[data-v-2ded7aa2] .switch > * {
  flex: auto !important;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/info/ChatInfo.vue"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB","sourcesContent":[".show-history-switch[data-v-2ded7aa2] .switch > * {\n  flex: auto !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
